export const QuotationsOrdersRoutes = {
    getQuotedOrders:"admin/get-all_quotes"
}